<template>
  <div class="bg-page-container">
    <!-- 页面头部 -->
    <div class="bg-page-header">
      <div class="header-title">
        <i class="el-icon-s-grid"></i>
        <span>二维码听力管理</span>
      </div>
    </div>

    <!-- 查询和操作区域 -->
    <div class="bg-toolbar">
      <div class="toolbar-left">
        <el-form :inline="true" size="small">
          <el-form-item label="产品级别">
            <el-select v-model="currentLevel" placeholder="请选择级别" @change="levelsChange" style="width: 150px">
              <el-option
                v-for="item in levelList"
                :key="item.productLevel"
                :label="item.productLevelName"
                :value="item.productLevel">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单元编号">
            <el-autocomplete
              v-model="keyword"
              :fetch-suggestions="querySearch"
              placeholder="请输入单元编号"
              @select="handleSelect"
              clearable
              style="width: 200px">
              <i class="el-icon-search el-input__icon" slot="suffix" @click="handleIconClick"></i>
            </el-autocomplete>
          </el-form-item>
        </el-form>
      </div>
      <div class="toolbar-right">
        <el-upload
          class="upload-inline"
          action=""
          :on-change="handleChange"
          :auto-upload="false"
          :show-file-list="false">
          <el-button slot="trigger" size="small" icon="el-icon-folder-opened">选取文件</el-button>
        </el-upload>
        <el-button size="small" type="success" icon="el-icon-upload" @click="uploadFile" :loading="uploadloading">上传</el-button>
        <el-button size="small" type="primary" icon="el-icon-download" @click="downloadFile" :loading="downloadloading">下载</el-button>
        <el-button size="small" type="warning" icon="el-icon-refresh" @click="createQR" :loading="qrloading">生成二维码</el-button>
      </div>
    </div>

    <!-- 数据表格 -->
    <div class="bg-table-section">
      <el-table
        :data="qrList"
        v-loading="loading"
        :height="bodyHeight"
        class="bg-table"
        stripe>
        <el-table-column prop="prodctCode" label="产品编码" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="productName" label="名称" min-width="150" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="productLevelName" label="级别" width="100" align="center">
        </el-table-column>
        <el-table-column prop="words" label="词语" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="table-words">{{ scope.row.words }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cnWords" label="翻译" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="table-words">{{ scope.row.cnWords }}</span>
          </template>
        </el-table-column>
        <el-table-column label="导图" width="80" align="center">
          <template slot-scope="scope">
            <div class="image-cell" v-if="scope.row.imageFilePath">
              <el-image
                :src="scope.row.imageFilePath"
                :preview-src-list="[scope.row.imageFilePath]"
                fit="cover"
                class="table-image">
                <div slot="error" class="image-error">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <span v-else class="no-data">-</span>
          </template>
        </el-table-column>
        <el-table-column label="二维码" width="80" align="center">
          <template slot-scope="scope">
            <div class="image-cell" v-if="scope.row.qrPath">
              <el-image
                :src="scope.row.qrPath"
                :preview-src-list="[scope.row.qrPath]"
                fit="cover"
                class="table-image">
                <div slot="error" class="image-error">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <span v-else class="no-data">-</span>
          </template>
        </el-table-column>
        <el-table-column label="语音" width="80" align="center">
          <template slot-scope="scope">
            <div class="audio-cell">
              <i
                :class="scope.row.audioIcon"
                class="audio-icon"
                @click="playAudio($event, scope.row)">
              </i>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="bg-pagination"
        background
        :page-size="pageSize"
        :current-page="pageIndex"
        @current-change="currentChange"
        :total="totalCount"
        :page-sizes="[15, 30, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange">
      </el-pagination>
    </div>

    <!-- 空状态 -->
    <bg-empty
      v-if="!loading && qrList.length === 0"
      icon="el-icon-s-grid"
      description="暂无二维码听力数据"
      hint="请使用查询条件筛选或上传数据">
    </bg-empty>

    <!-- 音频播放器 -->
    <audio src="/" ref="myaudio" controls style="display: none;"></audio>
  </div>
</template>

<script>
import api from '@/utils/api'
import BgEmpty from '@/components/common/BgEmpty'

export default {
  name: 'QRListening',
  components: {
    BgEmpty
  },
  data () {
    return {
      loading: false,
      uploadloading: false,
      downloadloading: false,
      qrloading: false,
      qrList: [],
      levelList: [],
      currentLevel: '',
      currentFile: '',
      totalCount: 0,
      pageIndex: 1,
      pageSize: 15,
      keyword: '',
      bodyHeight: 0
    }
  },
  created () {
    this.bodyHeight = (window.innerHeight - 280)
    this.init()
    this.querySearch()
  },
  methods: {
    init () {
      this.$axios.get(api.getQrProductLevels)
        .then(res => {
          this.levelList = res.data.result
          if (this.levelList.length > 0) {
            this.currentLevel = this.levelList[0].productLevel
          }
        })
    },
    currentChange (current) {
      this.pageIndex = current
      this.querySearch(this.keyword)
    },
    handleSelect (item) {
      this.keyword = item.Id
      this.querySearch(this.keyword)
    },
    handleIconClick () {
      this.querySearch(this.keyword)
    },
    querySearch (keyword, cb) {
      this.loading = true
      var queryList = []
      this.$axios.post(api.getQrListenings, {
        Level: this.currentLevel,
        ProductCode: keyword,
        PageIndex: this.pageIndex,
        PageSize: this.pageSize
      })
        .then((response) => {
          response.data.result.items.forEach((item) => {
            item.audioIcon = 'el-icon-video-play audio-action'
            queryList.push({ value: item.prodctCode, Id: item.prodctCode })
          })
          this.qrList = response.data.result.items
          this.totalCount = response.data.result.totalCount
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$message({ message: error.message || '查询失败', type: 'error' })
        })
      if (cb) {
        cb(queryList)
      }
    },
    handleChange (file) {
      this.currentFile = file
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.querySearch()
    },
    uploadFile () {
      var file = this.currentFile
      if (file === '') {
        this.$message({ message: '请先选择上传文件', type: 'warning' })
        return
      }
      var formData = new FormData()
      formData.append('file', file.raw)
      this.uploadloading = true
      var _this = this
      return this.$axios.post(api.uploadQrListening, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(res => {
          if (res.data.result === 'SUCCESS') {
            _this.uploadloading = false
            this.querySearch()
            _this.$message({ message: file.name + '文件上传成功', type: 'success' })
            _this.currentFile = ''
          } else {
            _this.uploadloading = false
            _this.$message({ message: res.data.result, type: 'error' })
          }
        })
        .catch(function (error) {
          _this.$message({ message: error.message, type: 'error' })
          _this.uploadloading = false
        })
    },
    downloadFile () {
      this.downloadloading = true
      this.$axios.post(api.downloadQrListening, { para: 1 }, { responseType: 'blob' })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; application/octet-stream' })
          const elink = document.createElement('a')
          elink.download = '二维码听力列表.xlsx'
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
          this.downloadloading = false
        })
        .catch((error) => {
          this.downloadloading = false
          this.$message({ message: error.message || '下载失败', type: 'error' })
        })
    },
    createQR () {
      this.qrloading = true
      this.$axios.post(api.createQr)
        .then(() => {
          this.$message({ message: '二维码生成成功', type: 'success' })
          this.querySearch()
          this.qrloading = false
        })
        .catch(() => {
          this.qrloading = false
        })
    },
    playAudio (event, row) {
      var audio = this.$refs.myaudio
      this.qrList.forEach((item) => {
        if (item.prodctCode !== row.prodctCode) {
          item.audioIcon = 'el-icon-video-play audio-action'
        }
      })
      if (row.audioIcon !== 'el-icon-video-pause audio-action') {
        audio.src = row.soundFilePath
        audio.play()
        row.audioIcon = 'el-icon-video-pause audio-action'
      } else {
        audio.pause()
        row.audioIcon = 'el-icon-video-play audio-action'
      }
    },
    levelsChange () {
      this.pageIndex = 1
      this.querySearch(this.keyword)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.bg-page-container {
  @include page-container;
}

.bg-page-header {
  @include flex-between;
  margin-bottom: $spacing-lg;
  padding: $spacing-md $spacing-lg;
  background: var(--bg-white);
  border-radius: $border-radius-base;
  box-shadow: var(--shadow-base);

  .header-title {
    display: flex;
    align-items: center;
    gap: $spacing-sm;
    font-size: $font-size-lg;
    font-weight: 600;
    color: var(--text-primary);

    i {
      font-size: $font-size-xl;
      color: $primary-color;
    }
  }
}

.bg-toolbar {
  @include flex-between;
  margin-bottom: $spacing-lg;
  padding: $spacing-md $spacing-lg;
  background: var(--bg-white);
  border-radius: $border-radius-base;
  box-shadow: var(--shadow-base);
  flex-wrap: wrap;
  gap: $spacing-md;

  .toolbar-left {
    .el-form-item {
      margin-bottom: 0;
    }
  }

  .toolbar-right {
    display: flex;
    gap: $spacing-sm;
    align-items: center;
  }

  .upload-inline {
    display: inline-block;
  }
}

.bg-table-section {
  @include table-section;

  .bg-table {
    border-radius: $border-radius-sm;
    overflow: hidden;

    .el-table__header {
      background: var(--gradient-header);

      th {
        font-weight: 600;
        color: var(--text-primary);
        background: transparent;
      }
    }

    .table-words {
      color: $warning-color;
      font-weight: 600;
    }

    .image-cell {
      display: flex;
      justify-content: center;
      align-items: center;

      .table-image {
        width: 50px;
        height: 50px;
        border-radius: $border-radius-sm;
        cursor: pointer;
        transition: $transition-base;
        border: 1px solid $border-light;

        &:hover {
          transform: scale(1.1);
          box-shadow: var(--shadow-base);
        }
      }

      .image-error {
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: $bg-base;
        border-radius: $border-radius-sm;
        color: $text-placeholder;
      }
    }

    .no-data {
      color: $text-placeholder;
    }

    .audio-cell {
      display: flex;
      justify-content: center;
      align-items: center;

      .audio-icon {
        font-size: 28px;
        color: $primary-color;
        cursor: pointer;
        transition: $transition-base;

        &:hover {
          color: $primary-light;
          transform: scale(1.1);
        }

        &.el-icon-video-pause {
          color: $warning-color;
        }
      }
    }
  }
}

.bg-pagination {
  margin-top: $spacing-lg;
  text-align: center;
}

// 响应式适配
@media (max-width: $screen-md) {
  .bg-toolbar {
    flex-direction: column;
    align-items: stretch;

    .toolbar-right {
      justify-content: flex-start;
      flex-wrap: wrap;
    }
  }
}

@media (max-width: $screen-sm) {
  .bg-page-header {
    flex-direction: column;
    gap: $spacing-md;
    align-items: flex-start;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bg/QRListening.vue